import { v4 } from "uuid";

import { api, urls } from "@aprosoja/api";
import { useToastFeedbackUser } from "@aprosoja/stores";

import { useSignUpContext } from "@/app/screens/sign-up/context/sign-up.context";
import { AddressStepFormValues } from "./schema";

const useAddressStep = () => {
  const { setToast } = useToastFeedbackUser();
  const { signUpReducer, setSignUpReducer } = useSignUpContext();

  const onSubmit = async (values: AddressStepFormValues) => {
    try {
      const response = await api.patch(`${urls.userAddress}`, values.address, {
        headers: {
          Authorization: `Bearer ${signUpReducer?.createdUserData?.access_token}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        setToast({
          id: v4(),
          title: `Endereço ${signUpReducer?.userAddress?.city ? "editado" : "cadastrado"} com sucesso!`,
          status: "success",
        });
        setSignUpReducer({
          type: "userAddress",
          userAddressPayload: values.address,
        });
        setSignUpReducer({ type: "signUpStep", signUpStepPayload: 2 });
      }
    } catch (err: any) {
      if (err?.response?.data?.statusCode === 400) {
        setToast({
          id: v4(),
          title: err?.response?.data?.message,
          status: "error",
        });
      } else {
        setToast({
          id: v4(),
          title:
            "Algo deu errado, verifique as informações e tente novamente em instantes.",
          status: "error",
        });
      }
    }
  };

  return { onSubmit };
};

export default useAddressStep;
